<template>
    <div v-arrowscroll>
        <div class="faq-categories" v-dragscroll="!isMobile">
            <div class="faq-categories__item" :class="{'faq-categories__item--active': currentCategory === 'all'}" @click="changeCategory('all')">
                Toate categoriile
            </div>
            <div class="faq-categories__item" v-for="(category, i) in categories" :class="{'faq-categories__item--active': currentCategory === category.name}" :key="i" @click="changeCategory(category.name)">
                {{category.name}}
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    //test discord git bot
    export default {
        data() {
            return {
                currentCategory: "all"
            }
        },
        props: {
            categories: {
                type: Array,
                default: null
            }
        },
        computed: {
            ...mapGetters({
                isMobile: 'layout/isMobile'
            })
        },
        methods: {
            changeCategory(selectedCategory) {
                this.currentCategory = selectedCategory;
                this.$emit('changedCategory', selectedCategory);
            }
        }
    }
</script>

<style lang="scss" scoped>
    .faq-categories {
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
        user-select: none;
        overflow-x: auto;
        padding-bottom: 3px;
        margin-top: 25px;

        &__item {
            font-size: 24px;
            font-weight: 500;
            line-height: 30px;
            letter-spacing: 0em;
            border-bottom: 3px solid;
            border-color: $color-card;
            position: relative;
            cursor: pointer;
            text-transform: capitalize;
            white-space: nowrap;

            &:not(:last-child) {
                margin-right: 30px;
            }

            &::after {
                content: "";
                position: absolute;
                height: 3px;
                width: 0;
                left: 50%;
                transform: translateX(-50%);
                bottom: -5px;
                background-image: $gradient-nexyo;
                transition: width .2s;
            }

            &--active {
                color: $color-primary;

                &::after {
                    width: 100%;
                }
            }

            &:hover {

                &::after {
                    width: 100%;
                }
            }
        }
    }
</style>